module.exports = __webpack_public_path__ + "static/media/Demo.f1094208.svg";